import {isFeatureEnabled} from 'feature-flags';

import {featureFlags} from '@dms/feature-flags';
import {
  CommentsTab,
  ActivitySidebar,
  ActivitySidebarV2,
  ActivitySidebarAction,
} from '@dms/features/activity-panel';
import i18n from '@dms/i18n';

import {buildArray} from 'shared/web';

import {ActivityTab} from './ActivityTab';

interface InterestActivityPanelProps {
  interestId: string;
}

export function InterestActivityPanel(props: InterestActivityPanelProps) {
  const actions = buildArray<ActivitySidebarAction>()
    .add({
      id: 'activity',
      label: i18n.t('entity.activityPanel.activity.title'),
      icon: 'sidebar/activity',
      component: <ActivityTab interestId={props.interestId} />,
    })
    .add({
      id: 'comments',
      label: i18n.t('entity.activityPanel.comments.title'),
      icon: 'communication/comment',
      component: <CommentsTab interestId={props.interestId} />,
    });

  if (isFeatureEnabled(featureFlags.REDESIGN_ACTIVITY_SIDEBAR)) {
    return <ActivitySidebarV2 actions={actions} />;
  }

  return <ActivitySidebar actions={actions} />;
}
